//#region Util Imports

import * as _ from 'underscore'
import * as $ from 'jquery'

//#endregion

//#region DevExpress Imports

import DevExpress from 'devextreme'
import 'devextreme/ui/button'
import 'devextreme/ui/form'
import 'devextreme/ui/file_uploader'
import 'devextreme/ui/popup'
import 'devextreme/ui/popover'

//#endregion

import { Api, LocalDictionaryFactory } from '../../api/api.module'
import { LoggerService } from '../../common/common.module'
import { FileModel, ColumnModel } from '../../api/api.models'
import { Activity } from '../../../models/common'
import { EventsNames } from '../../../helpers/events-names'
import { CommonHelper } from '../../../helpers/common-helper'
import { Md5 } from '../../../helpers/md5-helper'
import { TypeHelper } from '../../../helpers/type-helper'
import { GridBridge } from '../../common/common.interfaces'
import { i18n } from './../i18n/common.i18n'
import { GridOptions, GridTypes } from '../../common/grid/grid.controller'
import { OpFile } from '../../../models/core'
import { TemplateHelper, ConfigHelper } from '../../../helpers'
import { USER_SESSION_SERVICE_NAME, UserSessionService } from '../../../services/user-session'

//#region Asset Imports

import './grid-attachments-edit.scss'
import * as TEMPLATE from './grid-attachments-edit.tpl.html'

//#endregion


interface AttachmentsEditScope extends ng.IScope {
    gridOptions: GridOptions
    uploaderOptions: DevExpress.ui.dxFileUploaderOptions
    uploader: DevExpress.ui.dxFileUploader
    formOptions: DevExpress.ui.dxFormOptions
    form: DevExpress.ui.dxForm
    file: File
    cancelFileButton: DevExpress.ui.dxButtonOptions
    submitFileButton: DevExpress.ui.dxButtonOptions
    deleteButtonOptions: DevExpress.ui.dxButtonOptions
    attachFileButtonOptions: DevExpress.ui.dxButtonOptions
    submitFileButtonDisabled: boolean

    popoverOptions: DevExpress.ui.dxPopoverOptions
    buttonOptions: DevExpress.ui.dxButtonOptions
    popoverVisible: boolean
    uploaderVisible: boolean
    selectedItemsIds: number[]

    attachmentData: any
    source: GridBridge
    popupOptions: DevExpress.ui.dxPopupOptions
    popupVisible: boolean
    isRowSelected: () => boolean
    deleteButtonDisabled: boolean
    deleteFile: (ids: number[]) => void
    isAttachLoading: boolean
}


export class GridAttachmentsEditDirective implements ng.IDirective {
    private grid: DevExpress.ui.dxDataGrid
    private previousAddFileMd5: string
    private previousDeleteFileMd5: string
    private addFileFailed: boolean = false
    private deleteFileFailed: boolean = false
    private useLegacy: boolean = false

    constructor() {

    }

    restrict = 'E'
    scope = {
        source: '='
    }
    template = TEMPLATE

    link = (scope, element, attrs) => {
        scope.$watch("source", value => {
            scope.source = value
        })
    }

    controller = ['$scope', '$q', '$timeout', 'api', 'logger', 'localDictionary', USER_SESSION_SERVICE_NAME, ($scope: AttachmentsEditScope, $q: ng.IQService, $timeout: ng.ITimeoutService, api: Api, logger: LoggerService, localDictionary: LocalDictionaryFactory, userSession: UserSessionService) => {
        this.useLegacy = false

        $scope.popupVisible = false
        $scope.popoverVisible = false
        $scope.uploaderVisible = true
        $scope.submitFileButtonDisabled = true

        var gridDefer = $q.defer<DevExpress.ui.dxDataGrid>()

        $scope.popoverOptions = {
            width: 600,
            height: 250,
            target: '#popover_' + $scope.$id,
            bindingOptions: {
                visible: 'popoverVisible'
            },
            onHiding: () => {
                $scope.popoverVisible = false
            },
            onShowing: () => {
                if ($scope.uploader) $scope.uploader.reset()
                if ($scope.form) $scope.form.resetValues()
            }
        }

        $scope.popupOptions = {
            showTitle: true,
            showCloseButton: true,
            bindingOptions: {
                visible: 'popupVisible',
                title: 'source.title'
            },
            onHiding: () => {
                $scope.$root.$broadcast(EventsNames.CLOSE_GRID_ATTACHMENTS_EDIT_POPUP + $scope.source.popupId)
            },
            onShowing: () => {
                this.previousAddFileMd5 = ""
                this.previousDeleteFileMd5 = ""
            }
        }

        $scope.uploaderOptions = {
            selectButtonText: i18n('Common', 'SelectFile'),
            labelText: i18n('Common', 'DropFileHere'),
            width: '100%',
            height: '100%',
            readyToUploadMessage: i18n('Common', 'ReadyToUpload'),
            uploadMode: 'useForm',
            uploadedMessage: i18n('Common', 'Uploaded'),
            uploadFailedMessage: i18n('Common', 'UploadFailed'),
            showFileList: false,
            onInitialized: e => {
                $scope.uploader = e.component
            },
            onValueChanged: (e) => {
                if (e.value && e.value.length) {
                    $scope.uploaderVisible = false
                    $scope.file = e.value[0]
                    $scope.submitFileButtonDisabled = false
                }
                else {
                    $scope.uploaderVisible = true
                    $scope.submitFileButtonDisabled = true
                }
            }
        }


        var formItems = [
            {
                dataField: 'Description',
                label: { text: i18n('Popup', 'Description') },
                visible: true,
                editorType: 'dxTextArea',
                cssClass: 'text-area-description'
            }
        ]

        $scope.formOptions = {
            colCount: 1,
            height: 100,
            labelLocation: 'top',
            items: formItems,
            bindingOptions: {
                formData: 'attachmentData'
            },
            onInitialized: e => {
                $scope.form = e.component
            }
        }

        $scope.attachmentData = {
            Description: ""
        }

        $scope.$on(EventsNames.OPEN_GRID_ATTACHMENTS_EDIT_POPUP + $scope.source.popupId, (event: ng.IAngularEvent, ...args: any[]) => {
            $scope.popupVisible = true
        })

        const columnDeferred: JQueryDeferred<any[]> = $.Deferred()

        if ($scope.source.dictionaryMethodName != null) {
            this.useLegacy = true

            localDictionary[$scope.source.dictionaryMethodName]().then((defaultColumns: ColumnModel[]) => {
                const columns: any[] = _.map(defaultColumns, (value: ColumnModel) => {
                    const column = {
                        dataField: value.id,
                        caption: value.caption,
                        dataType: CommonHelper.getDataType(value)
                    }

                    if (value.type == CommonHelper.datetime) {
                        column['format'] = window['simax'].getDateFormat('DATE_FORMAT_DX')
                    }

                    return column
                })

                columnDeferred.resolve(columns)
            })
        } else {
            const columns: any[] = _.map($scope.source.columns, (value: ColumnModel) => {
                const column: DevExpress.ui.dxDataGridColumn = {
                    dataField: value.idName,
                    caption: value.caption,
                    dataType: CommonHelper.getDataType(value)
                }

                if (value.type == CommonHelper.datetime) {
                    column['format'] = window['simax'].getDateFormat('DATE_FORMAT_DX')
                }

                return column
            })

            columnDeferred.resolve(columns)
        }

        columnDeferred.then((columns: any[]) => {
            $scope.gridOptions = {
                name: 'IssueAttachments',
                type: GridTypes.SMALL,
                buttonsOptions: {
                    enabled: false,
                },
                addCustomFilters: false,
                allowColumnReordering: $scope.source.allowColumnReordering,
                columns,

                onInitialized: e => {
                    gridDefer.resolve(e.component)
                    this.grid = e.component
                },
            }
        })

        var addFile = (attachment) => {

            if ($scope.source.onAdd || $scope.source.onFileAdded) {
                var currentMd5 = Md5.init(attachment)
                if (this.previousAddFileMd5 !== currentMd5 || this.addFileFailed) {
                    this.previousAddFileMd5 = currentMd5

                    if ($scope.source.onAdd) {
                        $scope.source.onAdd(attachment).then(result => {

                            if (result) {
                                this.addFileFailed = false
                                $scope.source.items.push(result)
                                $scope.uploader.reset()
                                $scope.form.resetValues()
                                $scope.submitFileButtonDisabled = true
                                $scope.$root.$broadcast(EventsNames.ISSUE_ATTACHMENT_COUNT_CHANGED)
                            }
                            else {
                                this.addFileFailed = true
                            }
                        }).catch(() => {
                            this.addFileFailed = true
                        })
                    }

                    if ($scope.source.onFileAdded) {
                        $scope.isAttachLoading = true

                        $scope.source
                            .onFileAdded(createOpFile(attachment))
                            .then(result => {

                                if (result) {
                                    this.addFileFailed = false                                    
                                    $scope.source.items.push(result)
                                    $scope.uploader.reset()
                                    $scope.form.resetValues()
                                    $scope.submitFileButtonDisabled = true
                                    $scope.$root.$broadcast(EventsNames.ISSUE_ATTACHMENT_COUNT_CHANGED)                                    
                                }
                                else {
                                    this.addFileFailed = true
                                }
                            }).catch(() => {
                                this.addFileFailed = true
                            })
                            .finally(() => {
                                $scope.isAttachLoading = false
                            })
                    }
                }
            }
        }

        var createOpFile = (file: FileModel) => {
            const attachmentFile: OpFile = new OpFile()

            attachmentFile.physicalFileName = file.physicalFileName
            attachmentFile.description = file.description == '' ? null : file.description
            attachmentFile.insertDate = new Date()
            attachmentFile.fileBytes = file.fileBytes.split(',')[1]
            attachmentFile.size = atob(<string>attachmentFile.fileBytes).length

            return attachmentFile
        }

        $scope.deleteFile = (ids: number[]) => {
            var currentMd5 = Md5.init(ids)
            if (this.previousDeleteFileMd5 !== currentMd5 || this.deleteFileFailed) {
                this.previousDeleteFileMd5 = currentMd5
                if ($scope.source.onDelete) {
                    $scope.isAttachLoading = true
                    $scope.source.onDelete(ids).then(result => {
                        result.forEach(id => {
                            for (var i = 0; i < $scope.source.items.length; i++) {
                                var item = $scope.source.items[i]

                                if (item.id == id || item.idFile == id) {
                                    $scope.source.items.splice(i, 1)
                                    break
                                }
                            }
                        })
                        $scope.$root.$broadcast(EventsNames.ISSUE_ATTACHMENT_COUNT_CHANGED)

                        this.previousAddFileMd5 = TypeHelper.emptyString
                        this.deleteFileFailed = false
                    }).catch(() => {
                        this.deleteFileFailed = true
                    })
                        .finally(() => {
                            $scope.isAttachLoading = false
                        })
                }
            }
        }


        var togglePopover = () => {
            $scope.popoverVisible = !$scope.popoverVisible
        }

        $scope.cancelFileButton = {
            text: i18n("Common", "Cancel"),
            onClick: () => {
                if ($scope.uploader) $scope.uploader.reset()
                $scope.file = null
                $scope.uploaderVisible = true
                $scope.submitFileButtonDisabled = true
            }
        }

        $scope.submitFileButton = {
            text: i18n("Common", "Upload"),
            bindingOptions: {
                disabled: 'submitFileButtonDisabled'
            },
            onClick: () => {
                var file = new FileModel()
                file.description = $scope.attachmentData.Description
                file.size = $scope.file.size
                file.physicalFileName = $scope.file.name
                var reader = new FileReader()
                reader.onload = (e: any) => {
                    file.fileBytes = e.target.result
                    addFile(file)
                }
                reader.readAsDataURL($scope.file)

            }
        }

        if ($scope.source.deleteAttachmentPermission) {
            $scope.deleteButtonOptions = {
                text: i18n('Common', 'Delete'),
                onClick: () => {
                    let idsToDelete: number[] = null

                    if (this.useLegacy) {
                        idsToDelete = this.grid.getSelectedRowKeys().map((e: any) => e.id)
                    }
                    else {
                        idsToDelete = this.grid.getSelectedRowKeys().map((e: OpFile) => e.idFile)
                    }

                    if (_.size(idsToDelete) > 0) {
                        $scope.deleteFile(idsToDelete)
                    }
                },
                bindingOptions: {
                    disabled: 'deleteButtonDisabled'
                }
            }
        }

        $scope.attachFileButtonOptions = {
            activeStateEnabled: false,
            template: TemplateHelper.getIcon(ConfigHelper.Icon.ATTACH_FILE, userSession),
            hint: i18n('Popup', 'UploadAttachment'),
            onClick: togglePopover,
            bindingOptions: {
                disabled: 'buttonDisabled'
            }
        }

        $scope.$watch(() => {
            return this.grid ? this.grid.getSelectedRowKeys().length != 0 : false
        }, (value) => {
            $scope.deleteButtonDisabled = !value
        })


        $scope.$watchCollection('source.items', (items: any[]) => {
            gridDefer.promise.then(grid => {
                grid.option("dataSource").store().clear()
                items.forEach((item) => {
                    grid.option("dataSource").store().insert(item)
                })
                grid.refresh()
            })
        })
    }]
}